export default __webpack_public_path__ + "static/media/pcb_process_assemble.0daebdda.png";